import router from "@/router";
import store from "@/store";

export const cancelPayToPageEvent = 'cancelPayToPageEvent';

export function cancelPayToPage(bus) {
  bus.$on(cancelPayToPageEvent, (to) => {
    doAction(to);
  })
}

function doAction(to) {
  if (store.state.requestLoading === false && store.state.routerLoading === false) {
    setTimeout(() => {
      router.replace(to);
    }, 20)
  } else {
    setTimeout(() => {
      doAction(to);
    }, 20)
  }
}



// WEBPACK FOOTER //
// ./src/lib/cancelPayToPage.js